import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeContent } from './homeContainer';
import NewBookModal from '../../components/newBookModal';
import RadioAdModal from '../../components/RadioAdModal';
import Footer from './footer';
import { AboutUsSection } from './aboutUs';
import { StatsSection } from './successCard';
import { Managment } from './Managment';
import HowitWork from './howitWork';
import SupportForm from './supportForm';


// Variable outside component scope to persist during client-side navigation
let hasShownRadioModal = false;
let hasShownBookModal = false;

export function HomePage() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isScrolled, setIsScrolled] = useState(false);
    const [showRadioModal, setShowRadioModal] = useState(false);
    const [showBookModal, setShowBookModal] = useState(false);

    useEffect(() => {
        // Show Radio modal first after 2 seconds
        if (!hasShownRadioModal) {
            const timer = setTimeout(() => {
                setShowRadioModal(true);
                hasShownRadioModal = true;
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleRadioClose = () => {
        setShowRadioModal(false);
        // After closing radio, maybe show book after a short delay
        if (!hasShownBookModal) {
            setTimeout(() => {
                setShowBookModal(true);
                hasShownBookModal = true;
            }, 1000);
        }
    };


    useEffect(() => {
        window.scrollTo(0, 0);

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Check initial scroll position

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="w-full text-center min-h-screen relative overflow-hidden bg-gray-50">
            {/* Main content */}
            <div className="relative flex flex-col min-h-screen">
                {/* Scrolling Text Marquee (Premium Glass Look - Pinned to Nav) */}
                <div className={`${(!isMobile && !isScrolled) ? 'hidden' : 'block'} fixed top-[60px] left-0 w-full z-[80] backdrop-blur-xl bg-white/30 border-y border-white/20 pt-1.5 pb-0.5 overflow-hidden shadow-sm pointer-events-auto transition-all duration-300`}>
                    <Link to="/radio" className="flex w-max animate-marquee whitespace-nowrap hover:[animation-play-state:paused]">
                        <span className="text-[#2a1273] font-AndoraModernSerif font-bold text-xs sm:text-sm px-10 tracking-wide uppercase">
                            📻 Live: Darul Hadees Radio — Streaming Islamic Knowledge, Hadith & lectures. Click to Join!
                        </span>
                        {/* Duplicate for seamless loop */}
                        <span className="text-[#2a1273] font-AndoraModernSerif font-bold text-xs sm:text-sm px-10 tracking-wide uppercase">
                            📻 Live: Darul Hadees Radio — Streaming Islamic Knowledge, Hadith & lectures. Click to Join!
                        </span>
                        {/* Duplicate for seamless loop */}
                        <span className="text-[#2a1273] font-AndoraModernSerif font-bold text-xs sm:text-sm px-10 tracking-wide uppercase">
                            📻 Live: Darul Hadees Radio — Streaming Islamic Knowledge, Hadith & lectures. Click to Join!
                        </span>
                        {/* Duplicate for seamless loop */}
                        <span className="text-[#2a1273] font-AndoraModernSerif font-bold text-xs sm:text-sm px-10 tracking-wide uppercase">
                            📻 Live: Darul Hadees Radio — Streaming Islamic Knowledge, Hadith & lectures. Click to Join!
                        </span>
                        {/* Third copy for very wide screens */}
                        <span className="text-[#2a1273] font-AndoraModernSerif font-bold text-xs sm:text-sm px-10 tracking-wide uppercase">
                            📻 Live: Darul Hadees Radio — Streaming Islamic Knowledge, Hadith & lectures. Click to Join!
                        </span>
                    </Link>
                </div>


                <HomeContent isMobile={isMobile} />
                <AboutUsSection />
                <StatsSection />
                {/* <HowitWork /> */}
                {/* <SupportForm /> */}
                <Footer />
                {showRadioModal && <RadioAdModal onClose={handleRadioClose} />}
                {showBookModal && <NewBookModal onClose={() => setShowBookModal(false)} />}
            </div>
        </div>
    );
}
